import { createServerFn } from "@tanstack/react-start";

/**
 * Returns the public PostHog config for the browser.
 * The project API key is a publishable identifier — safe to expose to the client.
 * Lives in a server fn so the secret name (POSTHOG_API_KEY, no VITE_ prefix)
 * stays server-side and the value is read from runtime env at request time.
 */
export const getPostHogConfig = createServerFn({ method: "GET" }).handler(
  async () => {
    const apiKey = process.env.POSTHOG_API_KEY || null;
    const host = process.env.POSTHOG_HOST || "https://us.i.posthog.com";
    return { apiKey, host };
  },
);
